var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5217",
    "data-name": "Rectangle 5217",
    width: 20.254,
    height: 17.434,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13961",
    "data-name": "Group 13961",
    transform: "translate(-1688 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(1688 306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13481",
    "data-name": "Group 13481",
    transform: "translate(1695.432 315.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13480",
    "data-name": "Group 13480",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45541",
    "data-name": "Path 45541",
    d: "M2.4.05C3.976-.1,5.72.135,7.31.035A2.877,2.877,0,0,1,9.042.761c.556.531,1.124,1.948,1.875,2.075,2.214.142,4.6-.154,6.793.011a2.654,2.654,0,0,1,2.482,2.565c-.152,3.093.2,6.369,0,9.441a2.65,2.65,0,0,1-2.062,2.5c-5.333.111-10.7.094-16.035.009A2.662,2.662,0,0,1,0,14.939V2.518A2.642,2.642,0,0,1,2.4.05m8.349,9.38H7.7a2.179,2.179,0,0,0-.288.107.681.681,0,0,0,0,1.191,2.171,2.171,0,0,0,.288.107h3.051c-.241.366-.881.686-.881,1.163a.7.7,0,0,0,1.146.528,19.389,19.389,0,0,0,1.909-1.91.672.672,0,0,0,0-.967,19.389,19.389,0,0,0-1.909-1.91.7.7,0,0,0-1.146.528c0,.477.64.8.881,1.163",
    transform: "translate(0 0)",
    fill: "#111"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveGalleryIcon);
export default __webpack_public_path__ + "static/media/move_gallery_icon.6ffa2f10c61e94d4bba7502f1ad1c790.svg";
export { ForwardRef as ReactComponent };